const selectJackpots = state => {
  return {
    jackpots: state.event.jackpots,
    total: state.event.jackpots?.reduce((prev, curr) => prev + curr.Amount, 0),
    currency: state.event.jackpots?.[0]?.Currency || 'EUR',
  };
};

export default selectJackpots;
